/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useState } from 'react';
import { CarouselProvider, Slider, Slide, CarouselContext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { StyledSearchMiniCardSlider } from './SearchMiniCardSlider.styles';
import { SearchOutletMiniCard } from '../SearchOutletMiniCard';
import { miniCardHeight, miniCardWidth } from '../../../modules/utils/constants/constants';
import { eventUtil } from '@marriott/mi-ui-library';

const ActiveSlideTracker = (props: any) => {
  const carouselContext = useContext(CarouselContext);

  useEffect(() => {
    if (!carouselContext) return;
    const onSlideChange = () => {
      const updatedCurrentSlide = Math.ceil(carouselContext.state.currentSlide);
      const updatedActiveMarker = props?.uniqueSearchMarkers?.findIndex(
        (marker: any) =>
          marker?.lat === props?.searchData[updatedCurrentSlide]?.node?.property?.basicInformation?.latitude &&
          marker?.lng === props?.searchData[updatedCurrentSlide]?.node?.property?.basicInformation?.longitude
      );

      if (updatedActiveMarker !== props?.activeMarker) {
        eventUtil.dispatch('updateActiveMarker', updatedActiveMarker);
      }
    };
    carouselContext.subscribe(onSlideChange);
    return () => carouselContext.unsubscribe(onSlideChange);
  }, [carouselContext, props?.setCurrentSlide]);

  return null;
};

export const SearchMiniCardSlider = (props: any) => {
  const [currentSlide, setCurrentSlide] = useState(
    props?.isMobileView ? (props?.currentSlideIndex >= 0 ? props?.currentSlideIndex : 0) : 0
  );
  const [visibleSlides, setVisibleSlides] = useState(1);

  useEffect(() => {
    const slides = Math.max((props?.containerWidth - 32) / 348, 1);
    setVisibleSlides(slides);
  }, [props?.containerWidth]);

  return (
    <StyledSearchMiniCardSlider containerWidth={props?.containerWidth} miniCardLength={props?.searchResults?.length}>
      <div className="d-flex flex-column carousel-container ml-3 mr-2">
        <CarouselProvider
          naturalSlideWidth={miniCardWidth}
          naturalSlideHeight={miniCardHeight}
          totalSlides={props?.searchResults?.length}
          visibleSlides={visibleSlides}
          currentSlide={currentSlide}
          isIntrinsicHeight={true}
          infinite={false}
          className="carousel-provider"
        >
          {props?.isMobileView && (
            <ActiveSlideTracker
              setCurrentSlide={setCurrentSlide}
              searchData={props?.searchResults}
              uniqueSearchMarkers={props?.uniqueSearchMarkers}
              activeMarker={props?.activeMarker}
              setActiveMarker={props?.setActiveMarker}
              setcurrentSlideIndex={props?.setcurrentSlideIndex}
              handleOutletSelection={props?.handleOutletSelection}
            />
          )}
          <Slider className="carousel-slider">
            {props?.searchResults?.map((outlet: any, index: number) => (
              <Slide index={index} key={index}>
                <div className="slide-container d-flex align-items-center justify-content-center">
                  <SearchOutletMiniCard outlet={outlet} {...props} />
                </div>
              </Slide>
            ))}
          </Slider>
        </CarouselProvider>
      </div>
    </StyledSearchMiniCardSlider>
  );
};
